import { render } from "./BotonFormularioUsuarioEmpresa.vue?vue&type=template&id=7983c266&scoped=true"
import script from "./BotonFormularioUsuarioEmpresa.vue?vue&type=script&lang=js"
export * from "./BotonFormularioUsuarioEmpresa.vue?vue&type=script&lang=js"

import "./BotonFormularioUsuarioEmpresa.vue?vue&type=style&index=0&id=7983c266&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7983c266"]])

export default __exports__